import {EMIT_TOAST, IEmitToast, IRemoveToast, REMOVE_TOAST} from '../actions/questionToast.actions';
import {IQuestionAnswerType} from '../../incase-domain/elements/base/questionElementBase';

export interface QuestionToastReducerState {
    toasts: {
        questionId: string;
        type: IQuestionAnswerType;
    }[];
}

export const preloadedState: QuestionToastReducerState = {
    toasts: [],
};

export const questionToastReducer = (
    state: QuestionToastReducerState = preloadedState,
    action: IEmitToast | IRemoveToast
): QuestionToastReducerState => {
    switch (action.type) {
        case EMIT_TOAST:
            return {...state, toasts: [...state.toasts, action.payload]};
        case REMOVE_TOAST:
            return {...state, toasts: [...state.toasts].filter((toast) => toast.questionId !== action.payload)};
        default:
            return state;
    }
};
